import { Grid } from '@material-ui/core'
import i18n from '../../../translations/i18n'
import { PassiveCheckbox } from '../Checkboxes'

interface CheckboxListProps {
  informationOrder: string[]
  data: any
  translationPath: string
}

const CheckboxList = ({
  informationOrder,
  data,
  translationPath
}: CheckboxListProps) => (
  <Grid container direction='row' spacing={0}>
    {informationOrder &&
      informationOrder.map((key: string) => (
        <Grid item sm={6} key={key}>
          <PassiveCheckbox
            label={i18n.t(`${translationPath}.${key}`)}
            checkedValue={data[key]}
          />
        </Grid>
      ))}
  </Grid>
)

export default CheckboxList
